import NoImageIcon from '@/assets/icons/no-image-icon.svg?react';
import { Box } from '@mui/material';
import { Palette } from '@/themes/themeOverrides/Palette';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)({
    width: '100%',
    minWidth: '100px',
    minHeight: '100px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    backgroundColor: Palette.gray.gray75,
});

export const NoImage = ({ sx }) => {
    return (
        <StyledBox sx={sx}>
            <NoImageIcon />
        </StyledBox>
    );
};
